import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { ExamplesComponent } from './examples/examples.component';
import { SharedModule } from '../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '../core/auth.guard';
import { PrepareGuard } from '../core/core.module';
import { BasicLayoutComponent } from '../common/layouts/basicLayout.component';
import { UserListComponent } from './user-list/user-list.component';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { LoginOverviewComponent } from './login-overview/login-overview.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'admin',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'home', pathMatch: 'full' },
                    {
                        path: 'users',
                        component: UserListComponent,
                        data: { title: 'Users' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'users/:id',
                        component: UserDetailComponent,
                        data: { title: 'Users Detail' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'logins',
                        component: LoginOverviewComponent,
                        data: { title: 'Logins' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                ],
            },
        ]),
    ],
    declarations: [
        UserDetailComponent,
        UserListComponent,
        LoginOverviewComponent,
    ],
    exports: [],
})
export class AdminModule {}
